import React from 'react';
import PropTypes from 'prop-types';
import { MultiLineEllipsisText } from '@bingads-webui-react/multiline-ellipsis';
import { ImageExperienceImage } from '@bingads-webui-campaign-react/image-experience-model';
import { MultiImagePreview } from './multi-image-preview';

export class AdPlacementMultiImagePreview extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.multiLineTextRefs = [
      React.createRef(),
      React.createRef(),
      React.createRef(),
    ];

    this.isMobilePreview = (this.props.previewType === 'MobileMultiImage');
  }

  componentDidUpdate() {
    this.multiLineTextRefs.forEach((ref) => {
      if (ref.current) {
        ref.current.processText();
      }
    });
  }

  render() {
    const {
      images,
      previewTexts,
      previewContentClassName,
      imagePreviewHeight,
      i18n,
    } = this.props;
    const finalPreviewContentClassName =
      `${previewContentClassName} responsive-ad-preview-content`;

    this.isMobilePreview = (this.props.previewType === 'MobileMultiImage');

    return (
      !this.isMobilePreview ?
        <div
          className={finalPreviewContentClassName}
          rel="noopener noreferrer"
        >
          <div className="text-container">
            <MultiLineEllipsisText
              ref={this.multiLineTextRefs[0]}
              className="long-headline"
              text={previewTexts.longHeadline}
            />
            <MultiLineEllipsisText
              ref={this.multiLineTextRefs[1]}
              className="final-url"
              text={previewTexts.url}
            />
            <MultiLineEllipsisText
              ref={this.multiLineTextRefs[2]}
              className="description"
              text={previewTexts.description}
            />
          </div>
          <div className="desktop-multiImg-container">
            {
              images.map(imageObj => (
                <MultiImagePreview
                  images={imageObj && [imageObj]}
                  i18n={i18n}
                  previewTexts={previewTexts}
                  imagePreviewHeight={imagePreviewHeight}
                  isInsideImages
                  key={imageObj.idString}
                />
              ))
            }
          </div>
        </div> :
        <div
          className={finalPreviewContentClassName}
          rel="noopener noreferrer"
        >
          <MultiImagePreview
            images={images}
            i18n={i18n}
            previewTexts={previewTexts}
            imagePreviewHeight={imagePreviewHeight}
          />
        </div>
    );
  }
}

AdPlacementMultiImagePreview.propTypes = {
  images: PropTypes.arrayOf(PropTypes.instanceOf(ImageExperienceImage)).isRequired,
  previewTexts: PropTypes.shape({
    longHeadline: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  previewType: PropTypes.string.isRequired,
  previewContentClassName: PropTypes.string.isRequired,
  imagePreviewHeight: PropTypes.number.isRequired,
};

